import * as React from 'react';
import classNames from 'classnames';

export interface IFieldGroupProps {
    /** Label to display */
    label?: React.ReactNode;
    /** Mark row as required */
    required?: boolean;
    /** Checkboxes */
    isCheckboxes?: boolean;
}

const FieldGroup: React.FunctionComponent<IFieldGroupProps> = (props) => {
    const required = <span className="text-intent-danger">*</span>;

    return (
        <fieldset className={classNames(props.isCheckboxes ? 'form-control-checkbox-group' : 'form-control-group')}>
            {!!props.label && (
                <legend>{props.label} {props.required && required}</legend>
            )}
            {props.children}
        </fieldset>
    );
};

FieldGroup.displayName = 'FieldGroup';

export default FieldGroup;
